import type { IconType } from 'react-icons/lib';
import { cn } from '../../index';

type Props = {
  startContent?: React.ReactNode;
  icon?: { type: IconType; className: string };
  label?: string;
  endContent?: React.ReactNode;
  className?: string;
};

export const Icon = ({ startContent, label, endContent, className, icon }: Props) => {
  const Icon = icon?.type;
  return (
    <div className={cn('flex items-center gap-2', className)}>
      {startContent || (Icon ? <Icon className={icon.className} /> : null)}
      {label}
      {endContent}
    </div>
  );
};
